"use strict";
(function (global) {

 /**
 * Изменить региональные настройки веб-доступа.
 * Настройки применяют после завершения сессии пользователя.
 *
 * @function WebAccess.services.session.SetNewLanguage
 * @param {string} langCode Язык пользовательского интерфейса. Возможные значения: ru-RU, en-EN
 * @return {Deferred} Специальный deferred-объект.
 * @since 5.0.0.7200
 */
  global.session.SetNewLanguage = function (langCode) {
    return global.call("/Session.asmx/SetNewLanguage ", { LangCode: langCode });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


  /**
   * Изменить масштаб предпросмотра для всех документов.
   *
   * @param {string} caleValue Масштаб предпросмотра
   * @function WebAccess.services.session.setPreviewScale
   * @return {Deferred} Специальный deferred-объект.
   * @since 5.1.0.1505
   * @deprecated since 5.7.
   *
   * @example
   * // Установить 100%-масштаб предпросмотра для всех документов.
   * WebAccess.services.session.setPreviewScale("100%").done(function() {
   *  location.reload();
   * });
   */
  global.session.setPreviewScale = function (scaleValue) {
    const previewScaleStorageName = `preview-${WA.getLocation()}-previewScale`;
    localStorage.setItem(previewScaleStorageName, scaleValue);
  };

  /**
  * DEPRECATED
  * Изменить тему и сохранить ее имя в профиле пользователя.
  *
  * @function WebAccess.services.session.setTheme
  * @param {string} themeName Имя темы. Например, «green», «gray».
  * @param {string} themeType Вариант темы. Возможные значения: light, dark.
  * @return {Deferred} deferred-объект для управления отложенными вызовами.
  * @since 5.0.0.4301
  * @deprecated As of 5.5.0.1801
  * @example
  *
  * // Изменить текущую тему на стандартную – светло-голубую тему в темном варианте.
  * WebAccess.services.session.setTheme("blue","dark").done(function() {
  *  location.reload();
  * });
  */
  global.session.setTheme = function (themeName, opt_themeType) {
    // Оставили на тот случай, если в подключаемых модулях этот метод еще используется
    return {'success': false, 'warning': 'Themes are deprecated'};
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * DEPRECATED
  * Установить параметры пользовательской темы.
  *
  * @function WebAccess.services.session.setCustomTheme
  * @param {string} themeType Вариант темы. Возможные значения: light, dark.
  * @param {array} backgroundColor Базовый цвет фона темы, например, [126,233,12]
  * @param {array} textColor Базовый цвет текста
  * @return {Deferred} deferred-объект для управления отложенными вызовами.
  * @since 5.0.0.4301
  * @deprecated As of 5.5.0.1801
  * @example
  *
  * // Изменить текущую тему на произвольную с произвольными цветами.
  * WebAccess.services.session.setCustomTheme("light",[215,226,213],[0,0,0]).done(function() {
  *  location.reload()
  *  });
  */
  global.session.setCustomTheme = function (themeType, backgroundColor, textColor) {
    return {'success': false, 'warning': 'Themes are deprecated'};
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Добавляет новый объект в справочник, в котором содержатся последние выбранные объекты.
  *
  * @function WebAccess.services.session.addLastUsedObject
  * @param {string} referenceName Код справочника
  * @param {array} objectID ИД объекта
  * @param {array} objectName Имя объекта
  * @return {Deferred} Специальный deferred-объект.
  * @since 5.0.0.7200
  *
  * @example
  * // Добавить в справочник «Пользователи» объект с ИД=132970, наименование которого «Петров Иван Федорович».
  * WebAccess.services.session.addLastUsedObject("ПОЛ", 132970, "Петров Иван Федорович");
  */
  global.session.addLastUsedObject = function (referenceName, objectID, objectName) {
      return global.call("/Session.asmx/AddLastUsedObject", {ObjectID: objectID, ObjectName: objectName, ReferenceName: referenceName });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  *
  * Удаляет объект из справочника, в котором содержатся последние выбранные объекты.
  *
  * @function WebAccess.services.session.removeLastUsedObject
  * @param {array} objectID ИД объекта
  * @return {Deferred} Специальный deferred-объект.
  * @since 5.0.0.7200
  *
  * @example
  * // Удалить объект с ИД=132970 из списка последних выбранных.
  * WebAccess.services.session.removeLastUsedObject(132970);
  */
  global.session.removeLastUsedObject = function (objectID) {
    return global.call("/Session.asmx/RemoveLastUsedObject", { ObjectID: objectID });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Удалить ссылки на объект.
  *
  * @function WebAccess.services.session.deleteLinks
  * @param {WA.Link[]} links Ссылки для удаления
  * @param {integer} sourceID ИД источника, где хранятся ссылки
  * @param {OBJECT_TYPE} SourceType Тип источника
  * @param {WA.Link[]} unselectedLinks список невыбранных ссылок
  * @return {Deferred} Специальный deferred-объект.
  * @since 5.0.0.7200
  */
  global.session.deleteLinks = function (links, sourceID, sourceType, unselectedLinks) {
    var items = [];
    for (var i = 0; i < links.length; i++) {
      items[i] = links[i].toLinkModel();
    }
    var params = {
      Links: items,
      SourceID: sourceID,
      SourceType: objectTypeToString(sourceType),
      UnselectedLinks: unselectedLinks || [],
    };

    log.info('DELETE_LINKS', $.toJSON(params));
    return global.call("/Session.asmx/DeleteLinks", params);
  };


  /**
  * Вставить ссылки на объект.

  * @function WebAccess.services.session.pasteLinks
  * @param {WA.Link[]} links Ссылки для вставки
  * @param {integer} sourceID ИД источника, куда копируются ссылки
  * @param {OBJECT_TYPE} SourceType Тип источника
  * @return {Deferred} Специальный deferred-объект.
  * @since 5.0.0.7200
  */
  global.session.pasteLinks = function (links, destID, destType) {
    var items = [];
    for (var i = 0; i < links.length; i++) {
      items[i] = links[i].toLinkModel();
    }
    var params = {
      Links: items,
      DestID: destID,
      DestType: objectTypeToString(destType)
    };

    log.info('PASTE_LINKS', $.toJSON(params));

    return global.call("/Session.asmx/PasteLinksList", { Links: items, DestID: destID, DestType: objectTypeToString(destType) });
  };


})(window.WebAccess.services);
